export { default } from './DeliveryDetailPage'